import BaseConfigApi from "./BaseConfigApi";
import UpcomingActionRequestResource from "common/resources/Project/Config/UpcomingAction/UpcomingActionRequestResource";
import UpcomingActionResponseResource from "common/resources/Project/Config/UpcomingAction/UpcomingActionResponseResource";
import { createFormData } from "utils/FormData";

export default class UpcomingActionApi extends BaseConfigApi {
	protected override getBaseUrl(params: Record<string, string>): string {
		return `${super.getBaseUrl(params)}/upcoming-actions`;
	}

	/**
	 * @description Get all by project id
	 */
	public async getAllByProjectId(projectId: string): Promise<UpcomingActionResponseResource[]> {
		return this.getRequest<UpcomingActionResponseResource[]>(this.getBaseUrl({ projectId })).then((response) => UpcomingActionResponseResource.hydrateArray(response));
	}

	/**
	 * @description Get one by id
	 */
	public async getById(projectId: string, upcomingActionId: string): Promise<UpcomingActionResponseResource> {
		return this.getRequest<UpcomingActionResponseResource>(`${this.getBaseUrl({ projectId })}/${upcomingActionId}`).then((response) =>
			UpcomingActionResponseResource.hydrate(response),
		);
	}

	/**
	 * @description Download upcoming action image
	 */
	public async downloadImage(projectId: string, upcomingActionId: string): Promise<Blob> {
		return this.getBlobRequest(`${this.getBaseUrl({ projectId })}/${upcomingActionId}/image`);
	}

	/**
	 * @description Create a new upcoming action for a project
	 */
	public async create(projectId: string, request: UpcomingActionRequestResource, image?: File): Promise<UpcomingActionResponseResource> {
		const formData = createFormData(request);

		if (image) formData.append("file", image);

		return this.postRequestFormdata<UpcomingActionResponseResource>(this.getBaseUrl({ projectId }), formData).then((response) =>
			UpcomingActionResponseResource.hydrate(response),
		);
	}

	/**
	 * @description Update an upcoming action for a project
	 */
	public async update(projectId: string, upcomingActionId: string, request: UpcomingActionRequestResource, image?: File): Promise<UpcomingActionResponseResource> {
		const formData = createFormData(request);

		if (image) formData.append("file", image);

		return this.putRequestFormdata<UpcomingActionResponseResource>(`${this.getBaseUrl({ projectId })}/${upcomingActionId}`, formData).then((response) =>
			UpcomingActionResponseResource.hydrate(response),
		);
	}

	/**
	 * @description Delete an upcoming action for a project
	 */
	public async delete(projectId: string, upcomingActionId: string): Promise<void> {
		return this.deleteRequest(`${this.getBaseUrl({ projectId })}/${upcomingActionId}`);
	}
}
